var exception = {
  exports: {}
};

export { exception as e };
//# sourceMappingURL=exception.js.map
